/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Free_5Inputs */



/**
* | output |
* | --- |
* | "Export SRT, VTT, and TXT subtitle files" |
*
* @param {Signup_Feature_Free_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_free_5 = /** @type {((inputs?: Signup_Feature_Free_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Free_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "it") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "es") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
	return /** @type {LocalizedString} */ ("Export SRT, VTT, and TXT subtitle files")
});